/** Entries for the project settings search box. */
export const feedSettingsIndex = [
  {
    path: "/feed",
    title: "Data feed",
    keywords: ["feed", "api", "token", "key", "stream", "pipeline", "external", "download"],
  },
];
